// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popover-header {
  color: var(--ion-color-secondary);
  font-family: var(--font-secondary);
  font-weight: 500;
  font-size: 1.25rem;
}

.hideTopMargin {
  margin-top: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/popovers/popover-bonus-check/popover-bonus-check.component.scss"],"names":[],"mappings":"AAAA;EACI,iCAAA;EACA,kCAAA;EACA,gBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,wBAAA;AACJ","sourcesContent":[".popover-header {\r\n    color: var(--ion-color-secondary);\r\n    font-family: var(--font-secondary);\r\n    font-weight: 500;\r\n    font-size: 1.25rem;\r\n}\r\n\r\n.hideTopMargin {\r\n    margin-top: 0 !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
